// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var NothingLast = function (x) {
    return x;
};
var traverseMaybes = function (dictApplicative) {
    return function (f) {
        return function (arr) {
            return Data_Functor.map((dictApplicative.Apply0()).Functor0())(Data_Array.catMaybes)(Data_Traversable.traverse(Data_Traversable.traversableArray)(dictApplicative)(f)(arr));
        };
    };
};
var stableSortWith = function (dictOrd) {
    return function (keyFn) {
        var $33 = Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.snd);
        var $34 = Data_Array.sortWith(Data_Tuple.ordTuple(dictOrd)(Data_Ord.ordInt))(function (v) {
            return new Data_Tuple.Tuple(keyFn(v.value1), v.value0);
        });
        var $35 = Data_Array.mapWithIndex(Data_Tuple.Tuple.create);
        return function ($36) {
            return $33($34($35($36)));
        };
    };
};
var partitionMap = function (f) {
    return function (arr) {
        return Data_Foldable.foldl(Data_Foldable.foldableArray)(function (v) {
            return function (item) {
                var v1 = f(item);
                if (v1 instanceof Data_Either.Right) {
                    return {
                        lefts: v.lefts,
                        rights: Data_Array.cons(v1.value0)(v.rights)
                    };
                };
                if (v1 instanceof Data_Either.Left) {
                    return {
                        lefts: Data_Array.cons(v1.value0)(v.lefts),
                        rights: v.rights
                    };
                };
                throw new Error("Failed pattern match at Data.Array.Extra (line 40, column 32 - line 42, column 45): " + [ v1.constructor.name ]);
            };
        })({
            lefts: [  ],
            rights: [  ]
        })(arr);
    };
};
var partitionA = function (dictApplicative) {
    return function (p) {
        return function (arr) {
            return Data_Functor.map((dictApplicative.Apply0()).Functor0())(function (v) {
                var v1 = Data_Array.partition(Data_Tuple.snd)(v);
                return {
                    yes: Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(v1.yes),
                    no: Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.fst)(v1.no)
                };
            })(Data_Traversable.traverse(Data_Traversable.traversableArray)(dictApplicative)(function (x) {
                return Data_Functor.map((dictApplicative.Apply0()).Functor0())(Data_Tuple.Tuple.create(x))(p(x));
            })(arr));
        };
    };
};
var newtypeNothingLast = {
    Coercible0: function () {
        return undefined;
    }
};
var eqNothingLast = function (dictEq) {
    return Data_Maybe.eqMaybe(dictEq);
};
var ordNothingLast = function (dictOrd) {
    return {
        compare: function (x) {
            return function (y) {
                var v = Data_Newtype.unwrap()(y);
                var v1 = Data_Newtype.unwrap()(x);
                if (v1 instanceof Data_Maybe.Just && v instanceof Data_Maybe.Just) {
                    return Data_Ord.compare(dictOrd)(v1.value0)(v.value0);
                };
                if (v1 instanceof Data_Maybe.Just && v instanceof Data_Maybe.Nothing) {
                    return Data_Ordering.LT.value;
                };
                if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Nothing) {
                    return Data_Ordering.EQ.value;
                };
                if (v1 instanceof Data_Maybe.Nothing) {
                    return Data_Ordering.GT.value;
                };
                throw new Error("Failed pattern match at Data.Array.Extra (line 27, column 5 - line 31, column 23): " + [ v1.constructor.name, v.constructor.name ]);
            };
        },
        Eq0: function () {
            return eqNothingLast(dictOrd.Eq0());
        }
    };
};
var restoreOrderWith = function (dictOrd) {
    return function (keyFn) {
        return function (order) {
            var orderMap = Data_Map_Internal.fromFoldable(dictOrd)(Data_Foldable.foldableArray)(Data_Array.mapWithIndex(function (i) {
                return function (x) {
                    return new Data_Tuple.Tuple(x, i);
                };
            })(order));
            return stableSortWith(ordNothingLast(Data_Ord.ordInt))(function (x) {
                return Data_Map_Internal.lookup(dictOrd)(keyFn(x))(orderMap);
            });
        };
    };
};
export {
    NothingLast,
    partitionMap,
    partitionA,
    restoreOrderWith,
    stableSortWith,
    traverseMaybes,
    newtypeNothingLast,
    eqNothingLast,
    ordNothingLast
};
//# sourceMappingURL=index.js.map
